// Filename: collections/activitys
define('collections/calendar/personal-data/personal-data-types',[
    'underscore',
    'backbone',
    'mustache',
    'moment',
    'utils',
    'services/api',
    'services/i18n',
    // super class
    'src/plugins/infinite-collection',
    // Pull in the Model module from above
    'models/calendar/personal-data/personal-data-type'
], function(
    // libs
    _, Backbone, Mustache, moment, U,
    // src
    API,
    i18n,
    // super class
    InfiniteCollection,
    // model
    MPersonalDataType
) {

    var CPersonalDataTypes = InfiniteCollection.extend({
        model: MPersonalDataType,
        url: API.url("custom-datas/"),
        comparator: function(model) {
            return -model.get('global');
        }
    });

    return CPersonalDataTypes;
});

